import { useContext } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { variants } from "../../utils/animations";
import { BlogsContext } from "../../utils/context";
import { BsArrowRight } from "react-icons/bs";
import DottedBackground from "../../Components/DottedBackground";
import ProjectCard from "../../Components/ProjectCard";
import Self from "../../../Assets/self.png";
import AdplistLogo from "../../../Assets/Icons/adplist_logo.jpeg";
import { AiOutlineLinkedin, AiOutlineInstagram } from "react-icons/ai";

import "./styles.css";

const Home = () => {
  const blogsData = useContext(BlogsContext);
  const storyBlogs = blogsData.filter((v) => v.type === "stories");
  const designBlogs = blogsData.filter((v) => v.type === "project");
  const notebookBlogs = blogsData.filter((v) => v.type === "notebook");

  const scrollToTop = () => window.scrollTo(0, 0);
  const sectionLimit = 2;

  return (
    <div className='home__container'>
      <motion.div
        initial='hidden'
        whileInView='visible'
        variants={variants}
        className='home__hero'
      >
        <motion.div className='home__top'>
          <motion.div className='home__top__text'>
            <motion.h1 variants={variants}>Experience Designer</motion.h1>
            <motion.h1 variants={variants}>Author & Storyteller</motion.h1>
            <motion.p variants={variants}>
              Hi, I'm{" "}
              <Link
                to='/about'
                style={{
                  fontWeight: 500,
                  color: "var(--primary)",
                  textDecoration: "none",
                }}
              >
                Moubani
              </Link>
              , a{" "}
              <Link
                to='/digital'
                style={{
                  fontWeight: 500,
                  color: "var(--primary)",
                  textDecoration: "none",
                }}
              >
                UX Designer
              </Link>{" "}
              passionate about accessibility, storytelling, and inclusive
              design. I also write dual-language{" "}
              <Link
                to='/stories'
                style={{
                  fontWeight: 500,
                  color: "var(--primary)",
                  textDecoration: "none",
                }}
              >
                children’s stories
              </Link>{" "}
              that explore cultural diversity, representation, and belonging,
              with the hope of helping young readers see themselves and others
              with curiosity and empathy. Across both, my focus is the same:
              creating work that helps people feel{" "}
              <i>seen, heard, and understood</i>.
            </motion.p>

            <motion.div
              variants={variants}
              className='about__socialIconContainer'
            >
              <motion.div variants={variants} className='about__socialIcon'>
                <a
                  rel='noreferrer'
                  target='_blank'
                  href='https://www.linkedin.com/in/moubanircdesign'
                >
                  <AiOutlineLinkedin
                    style={{ fontSize: "3em", color: "var(--dark)" }}
                  />
                </a>
              </motion.div>
              <motion.div variants={variants} className='about__socialIcon'>
                <a
                  rel='noreferrer'
                  target='_blank'
                  href='https://www.instagram.com/storiesbymoubani'
                >
                  <AiOutlineInstagram
                    style={{ fontSize: "3em", color: "var(--dark)" }}
                  />
                </a>
              </motion.div>
              <motion.div variants={variants} className='about__socialIcon'>
                <a
                  rel='noreferrer'
                  target='_blank'
                  href='https://adplist.org/mentors/moubani-roy-choudhury'
                  aria-label='ADPList mentor profile'
                >
                  <img
                    className='about__socialIconImage about__socialIconImage--adplist'
                    src={AdplistLogo}
                    alt='ADPList'
                  />
                </a>
              </motion.div>
            </motion.div>
          </motion.div>
          <motion.div
            variants={variants}
            className='home__meImage' /*data-quote={ TEXTS[index % TEXTS.length] }*/
          >
            <img className='home__meImage' src={Self} alt='self' />
          </motion.div>

          {/* here */}
        </motion.div>

        <DottedBackground />
      </motion.div>

      <motion.div
        initial='hidden'
        whileInView='visible'
        variants={variants}
        className='home__horizontalLine'
      ></motion.div>

      <div className='home__cardContainer'>
        <Link
          style={{ textDecoration: "none" }}
          onClick={scrollToTop}
          to='stories'
        >
          <h3>Stories</h3>
        </Link>

        <div className='home__cards'>
          {storyBlogs?.slice(0, sectionLimit).map((item, index) => (
            <ProjectCard
              key={item.guid}
              title={item.title}
              thumbnail={item.thumbnail}
              description={item.description}
              content={item.content}
              timestamp={item.pubDate}
              subtitle={/(?:<.+?>)([^<>]*?)(?:<\/.*?>)/g.exec(item.content)[1]}
              width={"wide"}
            />
          ))}
        </div>
        <motion.p variants={variants}>
          <Link
            className='noLink seeMore'
            onClick={() => window.scrollTo(0, 0)}
            style={{ color: "var(--primary)", marginBottom: "2em" }}
            to='stories'
          >
            Read stories <BsArrowRight />
          </Link>
        </motion.p>
      </div>

      <motion.div
        initial='hidden'
        whileInView='visible'
        variants={variants}
        className='home__horizontalLine'
      ></motion.div>

      <div className='home__cardContainer'>
        <Link
          style={{ textDecoration: "none" }}
          onClick={scrollToTop}
          to='digital'
        >
          <h3>Design</h3>
        </Link>
        <div className='home__cards'>
          {designBlogs?.slice(0, sectionLimit).map((item, index) => (
            <ProjectCard
              key={item.guid}
              title={item.title}
              thumbnail={item.thumbnail}
              description={item.description}
              content={item.content}
              timestamp={item.pubDate}
              subtitle={/(?:<.+?>)([^<>]*?)(?:<\/.*?>)/g.exec(item.content)[1]}
              width={"wide"}
            />
          ))}
        </div>
        <motion.p variants={variants}>
          <Link
            className='noLink seeMore'
            onClick={() => window.scrollTo(0, 0)}
            to='digital'
          >
            Explore case studies <BsArrowRight />
          </Link>
        </motion.p>
      </div>

      <motion.div
        initial='hidden'
        whileInView='visible'
        variants={variants}
        className='home__horizontalLine'
      ></motion.div>

      <div className='home__cardContainer'>
        <Link
          style={{ textDecoration: "none" }}
          onClick={scrollToTop}
          to='notebook'
        >
          <h3>Notebook</h3>
        </Link>
        <div className='home__cards'>
          {notebookBlogs?.slice(0, sectionLimit).map((item, index) => (
            <ProjectCard
              key={item.guid}
              title={item.title}
              thumbnail={item.thumbnail}
              description={item.description}
              content={item.content}
              timestamp={item.pubDate}
              subtitle={/(?:<.+?>)([^<>]*?)(?:<\/.*?>)/g.exec(item.content)[1]}
              width={"wide"}
            />
          ))}
        </div>
        <motion.p variants={variants}>
          <Link
            className='noLink seeMore'
            onClick={() => window.scrollTo(0, 0)}
            to='notebook'
          >
            Open notebook <BsArrowRight />
          </Link>
        </motion.p>
      </div>

      <motion.div variants={variants} className='homeFooter__container'>
        <motion.p variants={variants}>
          Some{" "}
          <Link
            onClick={() => window.scrollTo(0, 0)}
            className='noLink'
            to='more'
          >
            <b style={{ color: "var(--primary)" }}>more</b>
          </Link>{" "}
          areas that I have explored are illustrations, branding,
          advertisements, and handicrafts.
        </motion.p>
        <motion.p variants={variants}>
          <Link
            className='noLink'
            style={{
              display: "flex",
              width: "6.5em",
              justifyContent: "space-between",
              alignItems: "center",
              color: "var(--primary)",
            }}
            onClick={() => window.scrollTo(0, 0)}
            to='/more'
          >
            see more <BsArrowRight />
          </Link>
        </motion.p>
        <DottedBackground />
      </motion.div>
    </div>
  );
};

export default Home;
